import viewportUnitsBuggyfill from 'viewport-units-buggyfill';

viewportUnitsBuggyfill.init({
	hacks: viewportUnitsBuggyfill.hacks,
	refreshDebounceWait: 250
});

let scrollCache = 0;
window.scrollCache = scrollCache;

// orientationchange
// window.addEventListener('resize', viewportUnitsBuggyfill.refresh, true);

// const Mirai = require('./include/_mirai')();
import ScrollCtrl from '@/include/_scroll';
import ScrollDownCtrl from '@/include/_scrolldown';
import NaviCtrl from '@/include/_gnavi';
import SearchCtrl from '@/include/_search';
import SoundCtrl from '@/include/_sound';

// Opening
// import Opening from '@/include/_opening';
import TouchCtrl from '@/include/_touch';
import MoreCtrl from '@/include/_moreajax';
import 'lity';

new NaviCtrl();
new SearchCtrl();
new TouchCtrl('a, button');
new ScrollCtrl();
new ScrollDownCtrl();
new MoreCtrl();
new SoundCtrl();

